import { clientVariableLineService } from "../services/clientVariableLine.service";
import { clientVariableLineConstants } from "../constants/clientVariableLine.constants";

export const clientVariableLineActions = {
  get,
  create,
  remove,
  update,
};

function get(requestParameters) {
  return (dispatch) => {
    dispatch(request(requestParameters));

    clientVariableLineService.get(requestParameters).then(
      (response) => {
        dispatch(success(response.data));
      },
      (error) => {
        dispatch(failure());
      }
    );
  };

  function request(requestParameters) {
    return {
      type: clientVariableLineConstants.GET_REQUEST,
      payload: requestParameters,
    };
  }
  function success(paginatedResult) {
    return {
      type: clientVariableLineConstants.GET_SUCCESS,
      payload: paginatedResult,
    };
  }
  function failure() {
    return { type: clientVariableLineConstants.GET_FAILURE };
  }
}

function create(requestParameters) {
  return (dispatch) => {
    dispatch(request(requestParameters));

    clientVariableLineService.create(requestParameters).then(
      (response) => {
        dispatch(success(response.data));
      },
      (error) => {
        dispatch(failure());
      }
    );
  };

  function request(requestParameters) {
    return {
      type: clientVariableLineConstants.CREATE_REQUEST,
      payload: requestParameters,
    };
  }
  // #2607: Create now returns the created line (VariableLineId included) instead of a
  // discarded response -- carried through so the caller can switch into editing the new
  // line immediately (e.g. to set a value type) instead of navigating away blind.
  function success(createdLine) {
    return { type: clientVariableLineConstants.CREATE_SUCCESS, payload: createdLine };
  }
  function failure() {
    return { type: clientVariableLineConstants.CREATE_FAILURE };
  }
}

function remove(requestParameters) {
  return (dispatch) => {
    dispatch(request());

    clientVariableLineService.remove(requestParameters).then(
      (response) => {
        dispatch(success());
      },
      (error) => {
        dispatch(failure());
      }
    );
  };

  function request() {
    return {
      type: clientVariableLineConstants.DELETE_REQUEST,
    };
  }
  function success() {
    return { type: clientVariableLineConstants.DELETE_SUCCESS };
  }
  function failure() {
    return { type: clientVariableLineConstants.DELETE_FAILURE };
  }
}

function update(requestParameters) {
  return (dispatch) => {
    dispatch(request(requestParameters));

    clientVariableLineService.update(requestParameters).then(
      (response) => {
        dispatch(success());
      },
      (error) => {
        dispatch(failure());
      }
    );
  };

  function request(requestParameters) {
    return {
      type: clientVariableLineConstants.UPDATE_REQUEST,
      payload: requestParameters,
    };
  }
  function success() {
    return { type: clientVariableLineConstants.UPDATE_SUCCESS };
  }
  function failure() {
    return { type: clientVariableLineConstants.UPDATE_FAILURE };
  }
}

// Note: picklist values are deliberately NOT routed through Redux (see
// clientVariableLineService.getPicklistValues/setPicklistValues, called directly from
// VariableLineForm.jsx/VariableGrid.jsx) -- both the standalone edit page and the grid's inline
// edit modal need their own per-instance copy of "this one line's picklist values," and a
// shared Redux slice would let them clobber each other (same class of bug as the project's
// known multi-window Redux-slice-clobbering issue elsewhere in Variables).
